import React from 'react';
import { ResidencePage } from '../../components/Views/ResidencePage';
import { getCurrentResidenceQuery } from '../../api/queries';
import Layout from '../../components/Layout/Layout';
import initApollo from '../../utils/init-Apollo';
import { getLocaleOnSSR } from '../../utils/helpers/getLocaleOnSSR';
import { getStaticData } from '../../utils/helpers/getStaticData';
import { getResidenceMockData } from '../../utils/helpers/getResidenceMockData';
import { normalizeItemPagePath } from '../../utils/helpers/item';
import { getSSRContextData } from '../../utils/helpers/ssrContext';
import { getResidenceSeoData } from '../../utils/helpers/seo';
import { withBugsnagGetServerSideProps } from '../../utils/withBugsnag';
import { extractApolloState } from '../../utils/helpers/extractApolloState';

const Residence = props => <ResidencePage {...props} />;

export const getServerSideProps = withBugsnagGetServerSideProps(
  async ({ res, req, query, resolvedUrl }) => {
    const lang = getLocaleOnSSR(req);
    const { platform } = getSSRContextData(req);

    // Map the internal path from `resolvedUrl` to the public-facing URL
    // to ensure correct canonical links and other SEO data.
    // WARNING: Must sync with `next.config.js` rewrites!
    const asPath = normalizeItemPagePath(
      resolvedUrl.replace('/residences/', '/yasayis-kompleksleri/')
    );

    if (query.mock === 'true' && process.env.NODE_ENV !== 'production') {
      return getResidenceMockData(lang, asPath, req);
    }

    res.setHeader(
      'Cache-Control',
      'public, max-age=300, s-maxage=300, stale-while-revalidate=86400'
    );

    const apolloClient = initApollo({}, { lang, platform });

    const residenceSlug = query.residence;

    try {
      const [residenceRes, staticData] = await Promise.all([
        apolloClient.query({
          query: getCurrentResidenceQuery,
          variables: { slug: residenceSlug },
          errorPolicy: 'all'
        }),
        getStaticData(apolloClient)
      ]);

      const residence = residenceRes?.data?.residence ?? null;
      if (!residence) {
        res.statusCode = 404;
      }

      return extractApolloState(apolloClient, {
        props: {
          seoData: getResidenceSeoData(residence?.name, lang, asPath, req),
          ...staticData,
          residence,
          residenceSlug,
          hasError: Boolean(residenceRes?.errors?.length),
          currentLang: lang
        }
      });
    } catch (error) {
      // Preserve no-store cache headers on error and let wrapper report the error
      res.setHeader('Cache-Control', 'no-store');
      throw error;
    }
  },
  '/residences/[residence]',
  {
    seoData: {},
    keywords: [],
    citiesUnPopularList: [],
    regions: {},
    residence: null,
    hasError: true
  }
);

Residence.getLayout = (page, pageProps) => (
  <Layout
    isBottomNavigation={false}
    isShowBackButton
    isShowCloseButton={false}
    pageProps={pageProps}
  >
    {page}
  </Layout>
);

export default Residence;
